module.exports = __webpack_public_path__ + "img/korea.27bab7b1.svg";